export default __webpack_public_path__ + "static/media/roboic.9652246f.jpg";